import type { EpgDateEx } from './index.h'

import { createEvent, createStore, sample } from 'effector'
import { model as clock } from '~/shared/clock'
import { generateWeek, getToday, isSameDate } from './lib'

export const init = createEvent()

// today
export const updateToday = createEvent()
export const $today = createStore<EpgDateEx>(getToday()) //
  .on(updateToday, (current) => {
    const updated = getToday()
    return isSameDate(current)(updated) ? current : updated
  })

// week from today to future, including today
export const $week = $today.map((today) => generateWeek(today))

sample({
  clock: [init, clock.$days],
  target: updateToday,
})
